import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { Credit } from '../../../types/items';
import { AdjustCreditRequest, AdjustCreditResponse, TransferCreditRequest } from './types';

/* List */
export const getCreditListRequest = action(
  'GET_CREDIT_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getCreditListSuccess = action(
  'GET_CREDIT_LIST_SUCCESS',
  withPayload<ItemList<Credit>>(),
);
export const getCreditListFail = action(
  'GET_CREDIT_LIST_FAIL',
  withoutPayload,
);

export const setCreditListDirty = action(
  'SET_CREDIT_LIST_DIRTY',
  withPayload<boolean>(),
);

export const clearCreditList = action(
  'CLEAR_CREDIT_LIST',
  withoutPayload,
);


/* Adjust Credits */
export const adjustCreditRequest = action(
  'ADJUST_CREDIT_REQUEST',
  withPayload<AdjustCreditRequest>(),
);
export const adjustCreditSuccess = action(
  'ADJUST_CREDIT_SUCCESS',
  withPayload<AdjustCreditResponse>(),
);
export const adjustCreditFail = action(
  'ADJUST_CREDIT_FAIL',
  withoutPayload,
);

/* Transfer Credits */
export const transferCreditRequest = action(
  'TRANSFER_CREDIT_REQUEST',
  withPayload<TransferCreditRequest>(),
);
export const transferCreditSuccess = action(
  'TRANSFER_CREDIT_SUCCESS',
  withPayload<AdjustCreditResponse>(),
);
export const transferCreditFail = action(
  'TRANSFER_CREDIT_FAIL',
  withoutPayload,
);
